type VisibilityHandlers = {
  handleOffVisibility: () => void;
  handleOnVisibility: () => {};
};

export const useVisibilityStatus = ({ handleOffVisibility, handleOnVisibility }: VisibilityHandlers) => {
  const handleVisibilityChange = () => {
    if (document?.visibilityState === 'visible') {
      handleOnVisibility();
    } else {
      handleOffVisibility();
    }
  };

  const setupVisibilityListeners = () => {
    document?.addEventListener('visibilitychange', handleVisibilityChange);
  };

  const cleanupVisibilityListeners = () => {
    document?.removeEventListener('visibilitychange', handleVisibilityChange);
  };

  return {
    cleanupVisibilityListeners,
    setupVisibilityListeners,
  };
};
